

import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ResultData } from '../_models/ResultData';
import { HeaderService } from './header.service';

@Injectable({
  providedIn: 'root'
})
export class LevelService {
  private headerService: HeaderService;
  constructor(private http: HttpClient,private injector: Injector) {}
  private getService(): HeaderService {
    if (!this.headerService) {
      this.headerService = this.injector.get(HeaderService);
    }
    return this.headerService;
  }
  levelsForCountryFlatten():Observable<ResultData>{
      const hh = this.getService().openJsonHeaders()
      return this.http.get<ResultData>(`${environment.apiUrl}/level/levelsForCountryFlatten`,{headers:hh})
  }


  getLevelIdAndNameByCurriculum(countryId: number):Observable<ResultData> {
    const hh = this.getService().openJsonHeaders()
    return this.http.get<ResultData>(`${environment.apiUrl}/level/getLevelIdAndNameByCurriculum/${countryId}`,{headers:hh})
  }
  getCurriculums() :Observable<ResultData> {
    const hh = this.getService().openJsonHeaders()
    return this.http.get<ResultData>(`${environment.apiUrl}/curriculum/getCurriculums`,{headers:hh})

  }

}
